import React from 'react';
import { useSelector } from 'react-redux';
import { getPoll, shouldShowResults } from '../../functions';
import PollAnswer from './PollAnswer';
import { TYPE } from './constant';
const PollItem = React.forwardRef(({ pollId, setCreateMode }, ref) => {
    const showResults = useSelector(shouldShowResults(pollId));
    const poll = useSelector(getPoll(pollId));
    return (React.createElement("div", { ref: ref }, poll?.status == TYPE.ENDED
        ? React.createElement(PollAnswer, { disabled: true, key: pollId, setCreateMode: setCreateMode, pollId: pollId })
        : React.createElement(PollAnswer, { disabled: false, pollId: pollId, setCreateMode: setCreateMode })));
});
export default PollItem;
